import { EventBus } from '@/services/Event.js';


export default {
    watch: {
        $route(to, from) {
            this.html = null;
        }
    },
    computed: {
        routeName() {
            const { name } = this.$route
            return this.capitalizeFirstLetter(name)
        },
        headerToShow() {
            if (this.html) {
                return this.html;
            }
            else {
                return this.routeName;
            }
        },
    },
    data() {
        return {
            activeNotifications: false,
            html: null
        };
    },
    methods: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications
        },
        closeDropDown() {
            this.activeNotifications = false
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false)
        },
        minimizeSidebar() {
            this.$sidebar.toggleMinimize()
        }
    },
    mounted() {
        var self = this;
        EventBus.$off('dashboard-header-update-html');
        EventBus.$on('dashboard-header-update-html', (newHtml) => {
            self.html = newHtml;
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/user/dashboard/header/header.js